import SiteLayout from "@/components/layouts/SiteLayout";

export default function PrivacyPolicy() {
  return (
    <SiteLayout
      title="Terms of Service | Makazi Mapya"
      description="Terms of Service of Makazi Mapya"
    >
      <div className="container mx-auto space-y-4 mb-20">
        <h1 className="text-3xl font-bold my-4">
          Terms of Service of Makazi Mapya
        </h1>

        <h2 className="text-2xl font-semibold mt-6">1. Introduction</h2>
        <p className="mt-2">
          Welcome to Makazi Mapya. These Terms of Service ("ToS") govern your
          use of our website located at makazimapya.com (the "Website"), which
          facilitates the advertisement and discovery of properties for sale and
          rent in Tanzania.
        </p>

        <h2 className="text-2xl font-semibold mt-6">2. User Accounts</h2>
        <ul className="list-disc ml-6 mt-2">
          <li>
            <strong>Sellers:</strong> Must link their Instagram account for ad
            synchronization or opt to send ad details and photos via WhatsApp.
          </li>
          <li>
            <strong>Buyers:</strong> Registration is required for receiving
            personalized ad alerts via email based on preferences.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6">3. Content and Ads</h2>
        <p className="mt-2">
          Users are responsible for the accuracy and legality of the content
          they provide. Makazi Mapya reserves the right to remove or edit
          content deemed inappropriate or in violation of these ToS.
        </p>

        <h2 className="text-2xl font-semibold mt-6">
          4. Notifications and Communications
        </h2>
        <p className="mt-2">
          By registering, buyers agree to receive email notifications related to
          their preferences. Communication regarding ad management (e.g.,
          deletion requests) must be directed to the specified WhatsApp number.
        </p>

        <h2 className="text-2xl font-semibold mt-6">
          5. Privacy and Data Protection
        </h2>
        <p className="mt-2">
          Your privacy is important to us. Please review our Privacy Policy,
          which explains how we handle personal data.
        </p>

        <h2 className="text-2xl font-semibold mt-6">6. Prohibitions</h2>
        <p className="mt-2">
          Users shall not misuse the Website. This includes, but is not limited
          to, spamming, spreading malicious software, or engaging in illegal
          activities.
        </p>

        <h2 className="text-2xl font-semibold mt-6">
          7. Disclaimer of Warranties and Liability
        </h2>
        <p className="mt-2">
          Makazi Mapya provides a platform for users to list and find
          properties. We are not involved in transactions between buyers and
          sellers and, as such, cannot guarantee the accuracy, safety, or
          legality of listings.
        </p>

        <h2 className="text-2xl font-semibold mt-6">8. Termination</h2>
        <p className="mt-2">
          We may terminate or suspend access to our service immediately, without
          prior notice, for any breach of these ToS.
        </p>

        <h2 className="text-2xl font-semibold mt-6">9. Governing Law</h2>
        <p className="mt-2">These ToS are governed by the laws of Tanzania.</p>

        <h2 className="text-2xl font-semibold mt-6">
          10. Changes to Terms of Service
        </h2>
        <p className="mt-2">
          We reserve the right to modify these ToS at any time. By continuing to
          use the Website after changes are made, you agree to be bound by the
          revised ToS.
        </p>

        <h2 className="text-2xl font-semibold mt-6">Contact Us</h2>
        <p className="mt-2">
          For any questions regarding these ToS, please contact us via WhatsApp
          at +255692184008 or through our Instagram page.
        </p>
      </div>
    </SiteLayout>
  );
}
